import React from 'react';
import TestChat from './testShell/TestChat';
import ryff from './testShell/configs/ryff';

// The Ryff scale in the chat, on the shared test shell (testShell/). The chat starts the
// session and passes it in (sessionId, savedProgress); scoring lives in testShell/configs/ryff.js.
const ChatbotRyff = (props) => <TestChat config={ryff} {...props} />;

export default ChatbotRyff;
